import { render, staticRenderFns } from "./newsone.vue?vue&type=template&id=05df2e16&scoped=true"
var script = {}
import style0 from "./newsone.vue?vue&type=style&index=0&id=05df2e16&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05df2e16",
  null
  
)

export default component.exports